module.exports = __webpack_public_path__ + "img/CAD.957882d4.png";